import React, { useState, useEffect } from 'react';
import axios from 'axios';
import params from '../config/Params';
import { getItemFromLocalStorage } from '../utils/storageUtils';
import { Helmet } from 'react-helmet';
import { useParams } from 'react-router-dom';

const GuestDetails = () => {
    const { bookingId, categoryId } = useParams();
    const [filteredBooking, setFilteredBooking] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    
    useEffect(() => {
        const fetchBookingDetails = async () => {
            setLoading(true);
            const hostData = getItemFromLocalStorage('hostProfile');
            let formData = new FormData();
            formData.append('token', hostData.host_access_token);
            formData.append('category', categoryId);
    
            try {
                const response = await axios({
                    method: 'post',
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    },
                    url: `${params.baseURL}${params.endpoints.getMyBooking}`,
                    data: formData
                });
    
                if (response.data && response.data.items.length > 0) {
                    const booking = response.data.items.find(
                        (item) => item.stay_booking_id === Number(bookingId)
                    );
                    setFilteredBooking(booking || null);
                } else {
                    setError('No booking data found for this category.');
                }
            } catch (err) {
                setError('An error occurred while fetching booking data.');
            } finally {
                setLoading(false);
            }
        };

        fetchBookingDetails();
    }, [categoryId, bookingId]);

    if (loading) {
        return <p>Loading...</p>;
    }

    if (error) {
        return <p>No booking found for the provided ID.</p>;
    }

    return (
        <div>
            <Helmet>
                <title>Guest Details</title>
                <meta name="description" content="" />
            </Helmet>

            <div className='booking-detail-section'>
                {filteredBooking && (
                    <>
                        <div className='category-img-section' style={{border:'2px solid #A9A9A9'}}>
                            <div className='gdpimgb'>
                                <img src={filteredBooking.guest_profile_image} alt='' className='img-fluid' />
                            </div>
                        </div>
                        <span className='b-line'></span>

                        <div>
                            <div className='bd-box'>
                                <strong>Guest info</strong>
                                <div className='bd-sub-box'>
                                    <div className='bd-ssb-box'>
                                        <img src={'/assets/img/icons/profile_icon.gif'} alt="" className="bd-icon" />
                                        <p>{filteredBooking.customer_name}</p>
                                    </div>
                                </div>
                                <div className='bd-sub-box'>
                                    <img src={'/assets/img/icons/whatsapp_icon_r.svg'} alt="" className="bd-icon" />
                                    <p>{filteredBooking.customer_phone}</p>
                                </div>
                                <div className='bd-sub-box'>
                                    <img src={'/assets/img/icons/workplace_icon.svg'} alt="" className="bd-icon" />
                                    <p>{filteredBooking.guest_workplace}</p>
                                </div>
                                <div className='bd-sub-box'>
                                    <img src={'/assets/img/icons/music_icon.svg'} alt="" className="bd-icon" />
                                    <p>{filteredBooking.guest_fav_song}</p>
                                </div>
                                <div className='bd-sub-box'>
                                    <img src={'/assets/img/icons/live_location_icon.svg'} alt="" className="bd-icon" />
                                    <p>{filteredBooking.guest_living_location}</p>
                                </div>
                                <div className='bd-sub-box'>
                                    <img src={'/assets/img/icons/school_icon.svg'} alt="" className="bd-icon" />
                                    <p>{filteredBooking.guest_school_name}</p>
                                </div>
                                <div className='bd-sub-box'>
                                    <img src={'/assets/img/icons/obsessed_icon.svg'} alt="" className="bd-icon" />
                                    <p>{filteredBooking.guest_obsessed}</p>
                                </div>
                                <div className='bd-sub-box'>
                                    <img src={'/assets/img/icons/birhtday_icon.svg'} alt="" className="bd-icon" />
                                    <p>{filteredBooking.guest_born_decade}</p>
                                </div>
                            </div>
                        </div>
                    </>
                )}
            </div>

        </div>
    );
};

export default GuestDetails;
